<template>
  <div class="kriszta">
    <img
      style="width:1px; height:1px;"
      :src="'https://servedby.flashtalking.com/imp/2/112659;4077673;201;pixel;Forbes;PSGCDDSFLATRNNETNTVForbesForbesForbesmicrositemltnative/?cachebuster='+timecurr()"
    />
    <div class="container">
      <h1 class="name">D. Tóth Kriszta</h1>
      <h2 class="subtitle">A tudatos autóhasználatról</h2>
      <div class="interju">interjú</div>
    </div>
    <div class="whtbg">
      <div class="container block">
        <div class="personpicbox">
          <img
            class="personpic"
            src="../assets/img/D.Toth-Kriszta-cikk.jpg"
            alt="D. Tóth Kriszta"
          />
          <img
            class="bluebox"
            src="../assets/img/blue-box.svg"
          />
        </div>
        <div class="coloredtitle">
          Van egy 14 éves gyereked. Amikor böngészi a híreket,
          nézi a közösségi hálót, látja merre halad a föld, mit mondasz
          neki a korosztályod és a felmenőid felelősségéről?
        </div>
        <p>Ez a korosztály, a „Z” generáció már nagyon valósan és tudatosan éli
          meg a klímaszorongást. Tisztában vannak azzal, hogy ők az első olyan nemzedék,
          akik már az életükben kénytelenek szembenézni azzal, hogy mit tettünk
          tönkre ezen a bolygón mi, a szüleik meg a nagyszüleik. Nekem szülőként most
          kettős feladatom van. Egyrészt elérni, hogy legalább ne romoljon a helyzet,
          másrészt pedig valahogy a gyerekem szorongását oldani. Hogy azért legyen gyerekkora.</p>
        <div class="anim bottom">
          <div class="coloredtitle">Vagyis tenni valamit, de közben valós életet is adni?</div>
          <p>Pontosan. Hogy ne csak a szorongás és a pánik legyen neki, miközben
            tisztában kell lennie a tényekkel és a lehetőségekkel, hogy ő mit tehet azért,
            hogy ez a helyzet ne romoljon.</p>
          <div class="coloredtitle">Te szorongsz?</div>
          <p>Miatta. Valószínűleg én már nem fogok élni akkor, amikor a nagy bajok
            jönnek. De kollektív lelkiismeret furdalásom van.</p>
        </div>
        <div class="clear"></div>
        <div class="anim bottom">
          <div class="coloredtitle">Mivel oldod?</div>
          <p>Azzal, hogy a gyerekünkből igyekeztünk magunknál jobb embert nevelni,
            illetve, hogy a mindennapi életünkben próbálunk okosan dönteni. Mondok egy példát.
            Jó dolog az internetes vásárlás, de számolni kell azzal, hogy van csomagolóanyag,
            a szállításnak is vannak káros melléktermékei. Szóval folyamatosan mérlegelünk.
            Tényleg szükségem van a kinézett termékre? Ha igen, akkor oké, nem megyünk el a
            boltba az autóval, rendeljük meg helyette? Az sem jó megoldás az említett okok miatt.
            Naponta száz ilyen döntést kell meghozni.</p>
        </div>
        <div class="anim bottom">
          <div class="coloredtitle">Miről szoktál le?</div>
          <p>A plasztikról. Mi nem csináltuk a plasticfreejulyt, mert a saját lelkiismeretünk
            és a gyerekünk nyomása miatt már jó ideje kiiktattuk az egyszer használatos
            műanyagokat otthon. Már rég nem veszünk ásványvizet palackban, hanem van vízszűrőnk
            és azzal isszuk a csapvizet. Próbálunk a pazarlásunkon is csökkenteni.
            A túlfogyasztást mérsékelni ételből és használati cikkekből is.
            Nehéz feladni a privilégiumokat, miközben tudjuk, hogy lemondással jár a
            környezettudatos élet.</p>
        </div>
      </div>
      <div class="galleryblock">
        <img
          src="../assets/img/mercedes-eqc-1.jpg"
          alt="Mercedes EQC"
        />
        <img
          src="../assets/img/mercedes-eqc-2.jpg"
          alt="Mercedes EQC interior"
        />
        <img
          src="../assets/img/mercedes-eqc-3.jpg"
          alt="Mercedes EQC"
        />
      </div>
      <div class="container block cols">
        <div class="colin">
          <div class="coloredtitle">Évek óta elektromos autóval jársz. Miért?</div>
          <p>Az Elviszlek magammal miatt kezdődött. Az első évad közepe
            felé jöttünk rá,
            hogy csak azért, hogy elkészülhessen egy online műsor, körbepöfögjük a várost,
            ráadásul két autóval. Akkor hoztunk egy döntést, hogy amint lehet, váltunk elektromosra.
            Tisztában vagyok a vitákkal, amelyek az elektromos közlekedést övezik,
            de én hiszek ebben
            a megoldásban. 2019-ben, a jelenlegi technológiaiadottságok mellett
            nem lehet jobban dönteni, ha már autóval kell közlekedni.
            Tudom, hogy nagy a gyártásnál a karbonlábnyom, de legalább nem a
            városban realizálódik a szennyezés.</p>
          <div class="coloredtitle anim bottom">Érdemes odafigyelni, hogy kitől veszed, és az hogyan
            gyártja.</div>
          <p class="anim bottom">Igen. Másfelől nem mindenkinek való az elektromos
            közlekedés. Például érdemes felmérni,
            hogy van e lehetőséged otthon tölteni az autót. Hogy mennyire van meg a városi
            infrastruktúrája a közlekedésnek. Javulgat egyébként, mert sok magáncég is elkezdett
            telepíteni töltőállomásokat. Mérlegelni kell tehát, hogy milyen az életstílusod,
            és egyelőre még azt is, hogy behozza-e az árát.
            Most már a modernebb akkumulátorok több száz
            kilométert bírnak, ezért nagyon várom,
            hogy elmehessek végre Kaposvárra az apukámhoz anélkül, hogy közben be kelljen terveznem
            egy megállót a töltésre.
          </p>
        </div>
        <div class="colin">
          <div class="coloredtitle">Vezetési élményben más?</div>
          <p>Sokkal gyorsabb és könnyebb. Én nagyon élvezem.
            A családomban több petrolhead is van,
            például az apósom autószerelő, aki mindent tud a motorokról, de még ő is szereti.
            Idejött Angliából, elvittem egy körre, és nagyon tetszett neki. Szóval jó élmény,
            de máshogy kell hozzáálni a használatához. Útvonalat, töltést tervezni, ami egyébként
            sokkal tudatosabb autóhasználatra tanít. Ez kifejezetten hasznos.</p>
          <div class="coloredtitle anim bottom">Mennyi időnk van még a Földön?</div>
          <p class="anim bottom">Nem vagyok vátesz, ezt meghagynám a tudósoknak. De nagyon
            bízom a gyerekeink generációjában. Ők egészen máshogy nyúlnak a
            problémákhoz, mint mi. Remélem, kitalálnak majd olyan megoldásokat,
            amit mi még el sem tudunk ma képzelni. És jó lenne, ha ők már
            nem is adnának lehetőséget olyan vezetőknek, vagy politikusoknak,
            akiknek ez a probléma nem fontos.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kriszta',
  components: {},
  data() {
    return {};
  },
  methods: {
    animateBoxes() {
      const picbox = document.querySelectorAll('.personpicbox');
      window.addEventListener(
        'scroll',
        () => {
          for (let index = 0; index < picbox.length; index += 1) {
            const element = picbox[index];
            this.moveCalculator(element);
          }
        },
        { passive: true },
      );
      window.addEventListener('touchmove', () => {
        for (let index = 0; index < picbox.length; index += 1) {
          const element = picbox[index];
          this.moveCalculator(element);
        }
      });
    },
    moveCalculator(element) {
      const itemCenter = element.offsetTop + element.offsetHeight / 2;
      const scrollStart = window.pageYOffset + window.innerHeight / 10;
      const scrollEnd = window.pageYOffset + (window.innerHeight / 10) * 9;
      const scrollMid = scrollStart + (scrollEnd - scrollStart) / 2;
      const scrollRange = itemCenter - scrollMid;
      const distance = 0.15;

      if (itemCenter <= scrollMid) {
        element
          .querySelector('.personpic')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange}px)`,
          );
        element
          .querySelector('.bluebox')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange * -2}px)`,
          );
      }
      if (itemCenter > scrollMid) {
        element
          .querySelector('.personpic')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange}px)`,
          );
        element
          .querySelector('.bluebox')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange * -2}px)`,
          );
      }
    },
    isinviewElement(array) {
      for (let index = 0; index < array.length; index += 1) {
        const element = array[index];
        if (element.getBoundingClientRect().top < window.innerHeight
          && element.getBoundingClientRect().bottom > 0) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      }
    },
    isinviewScroll() {
      const anim = document.querySelectorAll('.anim');
      window.addEventListener('scroll', () => {
        this.isinviewElement(anim);
      }, { passive: true });
      window.addEventListener('touchmove', () => {
        this.isinviewElement(anim);
      });
      window.addEventListener('Load', () => {
        this.isinviewElement(anim);
      });
    },
    timecurr() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth()}${time.getDate()}${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
    },
  },
  mounted() {
    this.animateBoxes();
    this.isinviewScroll();
  },
};
</script>
<style scoped lang="css">
.kriszta {
  padding-top: 60px;
}
.container.block {
  background-color: #fff;
  color: #151726;
  padding: 50px 60px;
  overflow: hidden;
}
.name {
  text-transform: uppercase;
  font-size: 18px;
  margin-block-start: 0;
  margin-block-end: 30px;
  font-weight: normal;
}
.subtitle {
  font-size: 77px;
  font-family: "Old Standard TT", serif;
  margin-block-start: 0;
  margin-block-end: 25px;
  font-weight: normal;
  line-height: 1;
}
.container {
  padding: 0 60px;
  width: calc(100% - 120px);
}
.interju {
  margin-bottom: 40px;
  color: #00adef;
  font-size: 18px;
}
.coloredtitle {
  color: #00adef;
  font-size: 21px;
  margin: 20px 0;
  line-height: 1.5;
}
.container p {
  font-size: 18px;
  line-height: 1.5;
}
.galleryblock {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-columns: 1fr 1fr 1fr;
}
.galleryblock img {
  width: 100%;
}
.galleryblock img:nth-child(1) {
  -ms-grid-column: 1;
}
.galleryblock img:nth-child(2) {
  -ms-grid-column: 2;
}
.galleryblock img:nth-child(3) {
  -ms-grid-column: 3;
}
.personpicbox {
  float: left;
  position: relative;
  overflow: hidden;
  display: -ms-flexbox;
}
.bluebox,
.personpic {
  width: 350px;
}
.bluebox {
  margin: 0 120px 40px 40px;
  z-index: 1;
  position: relative;
}
.personpic {
  position: absolute;
  left: 120px;
  bottom: -20px;
  z-index: 2;
}
.clear {
  clear: both;
  margin-top: 20px;
}
.cols {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr;
  -ms-grid-columns: 1fr 1fr;
}
.colin:nth-child(1) {
  padding-right: 30px;
  grid-column: 1/2;
  -ms-grid-column: 1;
}
.colin:nth-child(2) {
  padding-left: 30px;
  grid-column: 2/3;
  -ms-grid-column: 2;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.anim {
  overflow: hidden;
}
.anim.left {
  transform: translateX(-50%);
  transition: all 2s;
  opacity: 0;
}
.anim.left.active {
  transform: translateX(0%);
  opacity: 1;
}
.anim.right {
  transform: translateX(100%);
  transition: all 2s;
  opacity: 0;
}
.anim.right.active {
  transform: translateX(0%);
  opacity: 1;
}
.anim.top {
  transform: translateY(-50%);
  transition: all 2s;
  opacity: 0;
}
.anim.top.active {
  transform: translateY(0%);
  opacity: 1;
}
.anim.bottom {
  transform: translateY(100%);
  transition: all 2s;
  opacity: 0;
}
.anim.bottom.active {
  transform: translateY(0%);
  opacity: 1;
}
@media screen and (max-width: 767px) {
  .kriszta {
    padding-top: 30px;
  }
  .subtitle {
    font-size: 45px;
  }
  .container {
    padding: 0 30px;
    width: calc(100% - 60px);
  }
  .container.block {
    padding: 50px 30px;
  }
  .galleryblock {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
  }
  .container.block.cols {
    padding: 50px 30px 20px 30px;
  }
  .cols {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
  }
  .colin:nth-child(1) {
    padding-right: 0px;
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .colin:nth-child(2) {
    padding-left: 0px;
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .bluebox,
  .personpic {
    width: 250px;
  }
  .bluebox {
    margin: 0 80px 30px 0px;
  }
  .personpic {
    left: 45px;
    bottom: -10px;
  }
  .anim.left,
  .anim.right {
    transform: translateX(0%);
    opacity: 1;
  }
  .anim.top,
  .anim.bottom {
    transform: translateY(0%);
    opacity: 1;
  }
}
@media screen and (max-width: 640px) {
  .bluebox,
  .personpic {
    width: 200px;
  }
  .bluebox,
  .personpic {
    width: 200px;
  }
  .personpic {
    left: 30px;
  }
  .bluebox {
    margin: 0 55px 30px 0px;
  }
}
@media screen and (max-width: 540px) {
  .bluebox,
  .personpic {
    width: 160px;
  }
  .personpic {
    left: 20px;
  }
  .bluebox {
    margin: 0 50px 30px 0px;
  }
  .coloredtitle {
    font-size: 19px;
  }
  .subtitle {
    font-size: 40px;
  }
  .personpicbox {
    float: none;
  }
}
</style>
